import { Box, Image } from '@chakra-ui/react';

import warnConfirm from 'Asset/image/siglive-warn-confirm.svg';
import failedConfirm from 'Asset/image/siglive-failed-confirm.svg';

import { Condition } from 'Component/others';
import { useConfirmDrawer } from 'Store/confirm-drawer';
import Drawer from 'UiKit/drawer';
import { TextExtraBold, TextMedium } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';
import ButtonOutline from 'UiKit/button/buttonOutline';

import styles from './styles.module.css';
import ButtonLink from 'UiKit/button/buttonLink';

const imageMap = {
  warning: warnConfirm,
  failed: failedConfirm,
};

const ConfirmDrawer = () => {
  const {
    isOpen,
    title,
    description,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    onResetConfirmDrawer,
    type = 'warning',
    confirmStyle = 'solid',
    cancelStyle = 'outline',
    switchOrder = false,
  } = useConfirmDrawer();

  const handleConfirm = () => {
    onConfirm?.();
    onResetConfirmDrawer();
  };

  const handleCancel = () => {
    onCancel?.();
    onResetConfirmDrawer();
  };

  return (
    <Drawer isOpen={isOpen} onClose={onResetConfirmDrawer} draggable={true}>
      <Box className={styles['confirm-drawer__container']}>
        <Box className={styles['confirm-drawer__content']}>
          <Image src={imageMap[type]} alt={type} className={styles['confirm-drawer__image']} />
          <Box className={styles['confirm-drawer__text--container']}>
            <TextExtraBold fontSize="20px">{title}</TextExtraBold>
            <TextMedium fontSize="16px">{description}</TextMedium>
          </Box>
        </Box>
        <Box className={styles['confirm-drawer__buttons']} style={switchOrder ? { flexDirection: 'row-reverse' } : undefined}>
          <Condition statement={cancelStyle === 'outline'}>
            <ButtonOutline className={styles['confirm-drawer__button']} onClick={handleCancel}>
              {cancelText}
            </ButtonOutline>
          </Condition>
          <Condition statement={cancelStyle === 'link'}>
            <ButtonLink className={styles['confirm-drawer__button']} onClick={handleCancel}>
              {cancelText}
            </ButtonLink>
          </Condition>
          <Condition statement={cancelStyle === 'solid'}>
            <ButtonSolid className={styles['confirm-drawer__button']} onClick={handleCancel}>
              {cancelText}
            </ButtonSolid>
          </Condition>

          <Condition statement={confirmStyle === 'outline'}>
            <ButtonOutline className={styles['confirm-drawer__button']} onClick={handleConfirm}>
              {confirmText}
            </ButtonOutline>
          </Condition>
          <Condition statement={confirmStyle === 'link'}>
            <ButtonLink className={styles['confirm-drawer__button']} onClick={handleConfirm}>
              {confirmText}
            </ButtonLink>
          </Condition>
          <Condition statement={confirmStyle === 'solid'}>
            <ButtonSolid className={styles['confirm-drawer__button']} onClick={handleConfirm}>
              {confirmText}
            </ButtonSolid>
          </Condition>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ConfirmDrawer;
